export enum ACTIONS_ORDER {
    FETCH_ORDER_CODE = 'FetchOrderCode',
    FETCH_AND_SET_ORDER = 'FetchAndSetOrder',
    FETCH_SHIPPING_METHODS = 'FetchShippingMethods',
    CREATE_AND_SET_SHIPPING = 'CreateAndSetShipping',
    FETCH_PAYMENT_METHODS = 'FetchPaymentMethods',
    CREATE_PAYMENT = 'CreatePayment',
    FETCH_PAYMENT_ID = 'FetchPaymentId',
    FETCH_PAYMENT = 'FetchPayment',
    FETCH_SHIPPING_ID = 'FetchShippingId',
    FETCH_SHIPPING = 'FetchShipping',
}

export enum ACTIONS_TOASTS {
    CREATE_TOAST = 'CreateToast',
}
